import React from 'react'

export default function NoHistory() {
  return (
    <div className='nohistory'>
      <p>SignIn to save your Code History !!</p>
    </div>
  )
}
